import { PhoneCall, MapPin, Mail, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

export const Footer = () => {
  const { phoneNumber } = usePhoneBar();
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/assets/logos/safeway-logo.png" 
              alt="Safeway Roofing & Chimney Logo" 
              className="w-3/4 h-auto max-w-xs md:max-w-sm object-contain"
            />
            <p className="text-gray-300 leading-relaxed">
              Long Island's trusted roofing experts since 2007. Quality craftsmanship, reliable service, fully insured.
            </p>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Roof Installation</li>
              <li>Roof Repair</li>
              <li>Emergency Repairs</li>
              <li>Chimney Services</li>
              <li>Siding & Windows</li>
              <li>Storm Damage</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <PhoneCall className="w-5 h-5 text-primary" />
                <span className="text-gray-300">{phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-1" />
                <span className="text-gray-300">
                  80 Orville Dr Suite 127<br />
                  Bohemia, NY 11716
                </span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold">Get Free Estimate</h4>
            <p className="text-gray-300">
              Ready to protect your home? Get your free estimate today!
            </p>
            <div className="space-y-2">
              <Button
                size="lg"
                className="w-full bg-primary hover:bg-primary-dark text-primary-foreground font-semibold transition-all duration-200"
                onClick={() => window.location.href = `tel:${phoneNumber}`}
              >
                <PhoneCall className="w-4 h-4 mr-2" />
                Call Now
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="w-full border-white text-white hover:bg-white hover:text-gray-900 font-semibold transition-all duration-200"
                asChild
              >
                <a href="/book-appointment">
                  <Calendar className="w-4 h-4 mr-2" />
                  Book Appointment
                </a>
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © 2009-2024 Safeway Roofing & Chimney Inc. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};